export const ROUTES = {
  HOME: 'https://www.andme.org',
  CART: '/cart',
  EULA: '/eula',
  PRIVACY: '/privacy',
  CONTACT: '/contact',
  MARKETPLACE: '/marketplace',
  FAQ: '/faq',
  PURCHASE_CONFIRMATION: '/purchase-confirmation',
  LOGIN: '/login',
  LOGOUT: '/logout',
  SIGN_UP: '/register',
  ACCOUNT: '/account',
  BRANDS_CHECKOUT: '/brands/claim',
  BRANDS_DASHBOARD: '/brands',
  PUBLIC_PROFILE: '/:id',
  REFERRED_TO_PROFILE: '/:id/ref',
};
